import router from './router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { getToken } from './utils/auth.js' // getToken from cookie

NProgress.configure({ showSpinner: false })// NProgress Configuration
// permissiom judge function

const whiteList = ['/login', '/authredirect']// no redirect whitelist

router.beforeEach((to, from, next) => {  
  NProgress.start() // start progress bar
  if (getToken()) { // getToken() determine if there has token
    /* has token */
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      next()//
    }
  } else {
    /* has no token */
    if ((whiteList.indexOf(to.path) !== -1) || to.name === 'login') { // Na lista branca de login, digite diretamente
      next()
    } else {
      next('/login') // Caso contrário, todos redirecionam para a página de login
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js